(function($) {    

  let $categoriessliderlist = $('.ShortCode.Categories')
  if($categoriessliderlist.length) {

    const $slider = $categoriessliderlist.eq(0)

    const resize = () => {

      const slidescontainerhtml = $slider.html()
      $slider.empty()
      $slider.html(slidescontainerhtml)

      const $slidescontainer = $slider.find('.List ul')
      const $slides = $slidescontainer.find('li.Category')
      const containerwidth = $slidescontainer.width()
      const windowW = window.innerWidth
      const slidediv = windowW > 1150 ?
        4
        :
        windowW > 780 ?
          3
          :
          windowW > 544 ?
            2
            :
            1

      const slidesize = containerwidth / slidediv

      $slides.css('width', slidesize + 'px')

      $categoriessliderlist
      .imgScroll({
        btn01:".Button.Left",
        btn02:".Button.Right",
        step: slidesize,
        isScreen: false
      })
    }

    window.addEventListener(
      'resize',
      resize
    )
    resize()
  }

})(jQuery)